import { useToggleState, useEventCallback } from '@cian/react-utils';
import { ILabelProps, Label, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './LabelBox.css';
import { LabelLayoutDesktop, LabelLayoutMobile } from './components';
import { ILabelsProps, TColors } from '../../types/labels';

const LABEL_COLORS: Record<TColors, Pick<ILabelProps, 'color' | 'background'>> = {
  red: {
    color: 'fill_error_primary_active_100',
    background: 'fill_error_secondary_hover_16',
  },
  blue: {
    color: 'primary_100',
    background: 'primary_10',
  },
  gray: {
    color: 'black_100',
    background: 'gray6_100',
  },
};

export const LabelBox: React.FC<ILabelsProps> = ({ tooltipContent, tooltipTitle, icon, color, text }) => {
  const deviceType = useDeviceType();

  const labelRef = React.useRef<HTMLDivElement>(null);
  const { state: isOpen, toggle } = useToggleState();

  const handleClick = useEventCallback((event: React.MouseEvent<HTMLDivElement>) => {
    // не допускает отправку аналитики при клике на лейбл или тултип на сниппете
    event.stopPropagation();
  });

  const { LabelLayout, onLabelClick } = React.useMemo(() => {
    if (deviceType === 'desktop') {
      return { LabelLayout: LabelLayoutDesktop };
    }

    return { onLabelClick: toggle, LabelLayout: LabelLayoutMobile };
  }, [deviceType, toggle]);

  return (
    <LabelLayout
      toggleTooltip={toggle}
      tooltipContent={tooltipContent}
      tooltipTitle={tooltipTitle}
      tooltipOpened={isOpen}
      onClick={handleClick}
      className={styles['label-container']}
      ref={labelRef}
    >
      <Label {...LABEL_COLORS[color]} icon={icon} ref={labelRef} onClick={onLabelClick}>
        {text}
      </Label>
    </LabelLayout>
  );
};
